/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
// FLAGGED-FOR-REVIEW-2026-02: This file has residual unused vars / state
// setters / effect-deps that look like DROPPED-FEATURE references, not
// blind-orphan code (state setters never called, computed values never
// rendered, hooks with intentional dep omissions). Reviewer next step:
// walk each warning and decide either RESTORE the callsite that references
// the var, OR delete the var. Do NOT bulk-delete without review — several
// of these signal features that were half-migrated.
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

// eslint-disable-next-line no-unused-vars -- FLAGGED (2026-02): axios + API
// were used by a `fetchMarketplaceThemes` / `saveCustomTheme` flow that got
// removed. `buildCustomTheme` (below) also unused — restore the marketplace
// wiring OR delete these three references together as one atomic cleanup.
import axios from 'axios';
// eslint-disable-next-line no-unused-vars -- FLAGGED (2026-02): see comment above.
const API = process.env.REACT_APP_BACKEND_URL;

// ── Theme Definitions ──────────────────────────────────────────────────────
export const THEMES = {
  'studio-dark': {
    id: 'studio-dark',
    name: 'Studio Dark',
    category: 'dark',
    description: 'StudioBinder-inspired — default professional dark',
    preview: { bg: '#0D0F14', surface: '#13151C', accent: '#F5A623', text: '#FFFFFF' },
    vars: {
      '--cb-bg': '#0D0F14', '--cb-surface': '#13151C', '--cb-surface-h': '#1A1D24',
      '--cb-surface-a': '#242730', '--cb-border': '#1E2028',
      '--cb-accent': '#F5A623', '--cb-accent-h': '#E0961B', '--cb-accent-dim': 'rgba(245,166,35,0.10)',
      '--cb-text': '#FFFFFF', '--cb-text-sec': '#A0A4B8', '--cb-text-dim': '#6C7086',
      '--cb-row-a': '#0D0F14', '--cb-row-b': '#111319',
      '--cb-sidebar-bg': '#0D0F14', '--cb-sidebar-bdr': '#1E2028',
      '--background': '222 22% 7%', '--foreground': '0 0% 100%',
      '--card': '222 18% 9%', '--card-foreground': '0 0% 100%',
      '--primary': '37 90% 59%', '--primary-foreground': '0 0% 0%',
      '--border': '222 18% 14%', '--input': '222 18% 14%', '--ring': '37 90% 59%',
    },
  },
  'production-black': {
    id: 'production-black',
    name: 'Production Black',
    category: 'dark',
    description: 'Cinematic black & gold — for main stage presence',
    preview: { bg: '#000000', surface: '#0C0C0C', accent: '#D4A017', text: '#F5F0E8' },
    vars: {
      '--cb-bg': '#000000', '--cb-surface': '#0D0D0D', '--cb-surface-h': '#151515',
      '--cb-surface-a': '#1C1C1C', '--cb-border': '#222222',
      '--cb-accent': '#D4A017', '--cb-accent-h': '#B8890F', '--cb-accent-dim': 'rgba(212,160,23,0.10)',
      '--cb-text': '#F5F0E8', '--cb-text-sec': '#8A8070', '--cb-text-dim': '#504840',
      '--cb-row-a': '#000000', '--cb-row-b': '#090909',
      '--cb-sidebar-bg': '#000000', '--cb-sidebar-bdr': '#222222',
      '--background': '0 0% 0%', '--foreground': '36 33% 95%',
      '--card': '0 0% 5%', '--card-foreground': '36 33% 95%',
      '--primary': '43 79% 47%', '--primary-foreground': '0 0% 0%',
      '--border': '0 0% 13%', '--input': '0 0% 13%', '--ring': '43 79% 47%',
    },
  },
  'slate-pro': {
    id: 'slate-pro',
    name: 'Slate Pro',
    category: 'dark',
    description: 'Modern SaaS dark — focused, minimal, GitHub-inspired',
    preview: { bg: '#0F1117', surface: '#161B22', accent: '#58A6FF', text: '#E6EDF3' },
    vars: {
      '--cb-bg': '#0F1117', '--cb-surface': '#161B22', '--cb-surface-h': '#1C2333',
      '--cb-surface-a': '#243148', '--cb-border': '#21262D',
      '--cb-accent': '#58A6FF', '--cb-accent-h': '#388BFD', '--cb-accent-dim': 'rgba(88,166,255,0.10)',
      '--cb-text': '#E6EDF3', '--cb-text-sec': '#8B949E', '--cb-text-dim': '#484F58',
      '--cb-row-a': '#0F1117', '--cb-row-b': '#121820',
      '--cb-sidebar-bg': '#010409', '--cb-sidebar-bdr': '#21262D',
      '--background': '222 31% 8%', '--foreground': '210 17% 95%',
      '--card': '215 19% 12%', '--card-foreground': '210 17% 95%',
      '--primary': '212 92% 68%', '--primary-foreground': '0 0% 0%',
      '--border': '217 19% 16%', '--input': '217 19% 16%', '--ring': '212 92% 68%',
    },
  },
  'midnight-blue': {
    id: 'midnight-blue',
    name: 'Midnight Blue',
    category: 'dark',
    description: 'Blue-grey enterprise — steady, authoritative, trustworthy',
    preview: { bg: '#0A0E1A', surface: '#0D1630', accent: '#6E9EF7', text: '#E8EFF8' },
    vars: {
      '--cb-bg': '#0A0E1A', '--cb-surface': '#0D1630', '--cb-surface-h': '#112447',
      '--cb-surface-a': '#163057', '--cb-border': '#1F3A5F',
      '--cb-accent': '#6E9EF7', '--cb-accent-h': '#4D83F5', '--cb-accent-dim': 'rgba(110,158,247,0.10)',
      '--cb-text': '#E8EFF8', '--cb-text-sec': '#8BA4C0', '--cb-text-dim': '#4A6A8A',
      '--cb-row-a': '#0A0E1A', '--cb-row-b': '#0C1220',
      '--cb-sidebar-bg': '#060A12', '--cb-sidebar-bdr': '#1F3A5F',
      '--background': '222 40% 8%', '--foreground': '215 33% 95%',
      '--card': '222 50% 13%', '--card-foreground': '215 33% 95%',
      '--primary': '219 88% 70%', '--primary-foreground': '0 0% 0%',
      '--border': '215 50% 25%', '--input': '215 50% 25%', '--ring': '219 88% 70%',
    },
  },
  'light-studio': {
    id: 'light-studio',
    name: 'Light Studio',
    category: 'light',
    description: 'Clean Celtx-style light — crisp for bright environments',
    preview: { bg: '#F3F4F6', surface: '#FFFFFF', accent: '#E07B00', text: '#111827' },
    vars: {
      '--cb-bg': '#F3F4F6', '--cb-surface': '#FFFFFF', '--cb-surface-h': '#F9FAFB',
      '--cb-surface-a': '#F0F1F3', '--cb-border': '#E5E7EB',
      '--cb-accent': '#E07B00', '--cb-accent-h': '#C86D00', '--cb-accent-dim': 'rgba(224,123,0,0.08)',
      '--cb-text': '#111827', '--cb-text-sec': '#4B5563', '--cb-text-dim': '#9CA3AF',
      '--cb-row-a': '#FFFFFF', '--cb-row-b': '#F9FAFB',
      '--cb-sidebar-bg': '#1F2937', '--cb-sidebar-bdr': '#374151',
      '--background': '220 14% 96%', '--foreground': '222 47% 11%',
      '--card': '0 0% 100%', '--card-foreground': '222 47% 11%',
      '--primary': '28 100% 44%', '--primary-foreground': '0 0% 100%',
      '--border': '220 13% 91%', '--input': '220 13% 91%', '--ring': '28 100% 44%',
    },
  },
  'executive-white': {
    id: 'executive-white',
    name: 'Executive White',
    category: 'light',
    description: 'Minimal premium light — elegant, high-contrast, focused',
    preview: { bg: '#FFFFFF', surface: '#FAFAFA', accent: '#1A1A2E', text: '#0A0A0A' },
    vars: {
      '--cb-bg': '#FFFFFF', '--cb-surface': '#FAFAFA', '--cb-surface-h': '#F5F5F5',
      '--cb-surface-a': '#EEEEEE', '--cb-border': '#E8E8E8',
      '--cb-accent': '#1A1A2E', '--cb-accent-h': '#0D0D1F', '--cb-accent-dim': 'rgba(26,26,46,0.06)',
      '--cb-text': '#0A0A0A', '--cb-text-sec': '#525252', '--cb-text-dim': '#A3A3A3',
      '--cb-row-a': '#FFFFFF', '--cb-row-b': '#FAFAFA',
      '--cb-sidebar-bg': '#0A0A0A', '--cb-sidebar-bdr': '#1A1A1A',
      '--background': '0 0% 100%', '--foreground': '0 0% 4%',
      '--card': '0 0% 98%', '--card-foreground': '0 0% 4%',
      '--primary': '237 56% 20%', '--primary-foreground': '0 0% 100%',
      '--border': '0 0% 91%', '--input': '0 0% 91%', '--ring': '237 56% 20%',
    },
  },
  'neon-production': {
    id: 'neon-production',
    name: 'Neon Production',
    category: 'dark',
    description: 'Dark with electric accents — cinematic energy and intensity',
    preview: { bg: '#06070D', surface: '#0D0F1A', accent: '#00E5A0', text: '#EEEEFF' },
    vars: {
      '--cb-bg': '#06070D', '--cb-surface': '#0D0F1A', '--cb-surface-h': '#131526',
      '--cb-surface-a': '#191C32', '--cb-border': '#1E2040',
      '--cb-accent': '#00E5A0', '--cb-accent-h': '#00C98C', '--cb-accent-dim': 'rgba(0,229,160,0.08)',
      '--cb-text': '#EEEEFF', '--cb-text-sec': '#8B90B8', '--cb-text-dim': '#4A5070',
      '--cb-row-a': '#06070D', '--cb-row-b': '#0A0B14',
      '--cb-sidebar-bg': '#040508', '--cb-sidebar-bdr': '#1E2040',
      '--background': '236 52% 4%', '--foreground': '240 40% 97%',
      '--card': '236 36% 8%', '--card-foreground': '240 40% 97%',
      '--primary': '160 100% 45%', '--primary-foreground': '0 0% 0%',
      '--border': '237 44% 18%', '--input': '237 44% 18%', '--ring': '160 100% 45%',
    },
  },
};

// ── Helpers ────────────────────────────────────────────────────────────────
function applyVarsToRoot(vars) {
  const root = document.documentElement;
  Object.entries(vars).forEach(([k, v]) => root.style.setProperty(k, v));
}

function buildCustomTheme(base, overrides) {
  return { ...THEMES[base]?.vars, ...overrides };
}

// ── Context ────────────────────────────────────────────────────────────────
const ThemeCtx = createContext(null);

const STORAGE_KEY = 'cb_theme_v1';
const STORAGE_CUSTOM_KEY = 'cb_custom_themes_v1';

export function ThemeProvider({ children }) {
  const [activeId, setActiveId] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY))?.id || 'studio-dark'; }
    catch { return 'studio-dark'; }
  });
  const [previewId, setPreviewId] = useState(null);
  const [customAccent, setCustomAccentState] = useState(null);
  const [density, setDensityState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY))?.density || 'comfortable'; }
    catch { return 'comfortable'; }
  });
  const [fontScale, setFontScaleState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY))?.fontScale || 1.0; }
    catch { return 1.0; }
  });
  const [userThemes, setUserThemes] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_CUSTOM_KEY)) || []; }
    catch { return []; }
  });

  const resolvedId = previewId || activeId;
  const resolvedTheme = THEMES[resolvedId] || userThemes.find(t => t.id === resolvedId) || THEMES['studio-dark'];

  // Apply vars whenever resolved theme changes
  // ⚠️  Landing page (path="/") always uses fixed dark/amber theme regardless of stored preference
  useEffect(() => {
    const isLandingPage = window.location.pathname === '/';

    const vars = isLandingPage
      ? {
          '--cb-bg':         '#0a0a0a',
          '--cb-surface':    '#141414',
          '--cb-surface-h':  '#1a1a1a',
          '--cb-border':     '#1E2028',
          '--cb-text':       '#f0f0f0',
          '--cb-text-sec':   '#A0A4B8',
          '--cb-text-dim':   '#606060',
          '--cb-accent':     '#F5A623',
          '--cb-accent-h':   '#F5A623',
          '--cb-accent-dim': 'rgba(245,166,35,0.15)',
          '--cb-card':       '#13151C',
        }
      : { ...resolvedTheme.vars };

    if (!isLandingPage && customAccent && !previewId) {
      vars['--cb-accent'] = customAccent;
      vars['--cb-accent-h'] = customAccent;
    }

    applyVarsToRoot(vars);

    if (isLandingPage) {
      document.documentElement.setAttribute('data-theme', 'studio-dark');
      document.documentElement.removeAttribute('data-theme-light');
      document.documentElement.style.setProperty('--cb-density', '1');
      document.documentElement.style.setProperty('font-size', '1rem');
    } else {
      document.documentElement.style.setProperty('--cb-density', density === 'compact' ? '0.85' : '1');
      document.documentElement.style.setProperty('font-size', `${fontScale}rem`);
      document.documentElement.setAttribute('data-theme', resolvedId);
      document.documentElement.setAttribute('data-density', density);
      const isLightFamily = resolvedId.startsWith('light') || resolvedId === 'executive-white';
      if (isLightFamily) {
        document.documentElement.setAttribute('data-theme-light', '1');
      } else {
        document.documentElement.removeAttribute('data-theme-light');
      }
    }
  }, [resolvedId, resolvedTheme, customAccent, previewId, density, fontScale]);

  const applyTheme = useCallback((id, accent = null) => {
    setPreviewId(null);
    setActiveId(id);
    if (accent) setCustomAccentState(accent);
    const saved = { id, density, fontScale, accent };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
  }, [density, fontScale]);

  const previewTheme = useCallback((id) => setPreviewId(id), []);
  const clearPreview = useCallback(() => setPreviewId(null), []);

  const setCustomAccent = useCallback((color) => {
    setCustomAccentState(color);
    const saved = { id: activeId, density, fontScale, accent: color };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
  }, [activeId, density, fontScale]);

  const setDensity = useCallback((mode) => {
    setDensityState(mode);
    const saved = { id: activeId, density: mode, fontScale };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
  }, [activeId, fontScale]);

  const setFontScale = useCallback((scale) => {
    setFontScaleState(scale);
    const saved = { id: activeId, density, fontScale: scale };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
  }, [activeId, density]);

  const saveUserTheme = useCallback((theme) => {
    const updated = [...userThemes.filter(t => t.id !== theme.id), theme];
    setUserThemes(updated);
    localStorage.setItem(STORAGE_CUSTOM_KEY, JSON.stringify(updated));
  }, [userThemes]);

  const deleteUserTheme = useCallback((id) => {
    const updated = userThemes.filter(t => t.id !== id);
    setUserThemes(updated);
    localStorage.setItem(STORAGE_CUSTOM_KEY, JSON.stringify(updated));
    if (activeId === id) applyTheme('studio-dark');
  }, [userThemes, activeId, applyTheme]);

  return (
    <ThemeCtx.Provider value={{
      activeId, previewId, resolvedId, resolvedTheme,
      customAccent, density, fontScale,
      userThemes, allThemes: [...Object.values(THEMES), ...userThemes],
      applyTheme, previewTheme, clearPreview,
      setCustomAccent, setDensity, setFontScale,
      saveUserTheme, deleteUserTheme,
    }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export const useTheme = () => {
  const ctx = useContext(ThemeCtx);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
};
